import React from 'react';

'use strict';

export default class HeaderNav extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ul className="navbar-nav align-items-stretch">
                {this.props.user ?
                    <li className={"nav-item nav-item-wide" + (this.props.activeSection === "User" ? " active" : "")}>
                        <div style={{ position: "relative" }}>
                            <a className="nav-link" href={this.props.userUrl}>{this.props.user}
                                {this.props.userNotifications ?
                                    <span className="badge">
                                        {this.props.userNotifications}
                                    </span> : null
                                }
                            </a>
                        </div>
                    </li> : null
                }

                {this.props.userNotifications || this.props.hideRecommendations ? null :
                    <li className={"nav-item nav-item-wide" + (this.props.activeSection === "Recommended" ? " active" : "")}>
                        <a className="nav-link" href={this.props.recommendedUrl}>{this.props.recommended}</a>
                    </li>
                }

                {this.props.userNotifications ? null :
                    <li className={"nav-item nav-item-narrow" + (this.props.activeSection === "Library" ? " active" : "")}>
                        <a className="nav-link" href={this.props.libraryUrl}>{this.props.library}</a>
                    </li>
                }

                {this.props.facilityResourcesUrls ?
                    <li className="nav-item nav-item-medium dropdown">
                        <a className="nav-link dropdown-toggle" href="#" id="navbarResources" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{this.props.facilityResources}</a>
                        <div className="dropdown-menu" aria-labelledby="navbarResources">
                            {this.props.facilityResourcesUrls.map(r =>
                                <a className="dropdown-item" target="_blank" href={r.url[this.props.language]}>{r.label[this.props.language]}</a>)
                            }
                        </div>
                    </li> : null
                }
            </ul>
        );
    }
}